import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  path = '', 
  image = 'https://velvetstreams.xyz/og-image.png',
  type = 'website' 
}) => {
  const siteName = 'VelvetStream';
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} - Premium Adult Entertainment`;
  const defaultDescription = 'Stream premium adult entertainment. Browse trending videos, discover new content across 150+ categories, and enjoy an ad-free experience with VelvetStream Premium.';
  const desc = description || defaultDescription;
  const url = `https://velvetstreams.xyz${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="en_US" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />

      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="rating" content="adult" />
      <meta name="rating" content="RTA-5042-1996-1400-1577-RTA" />
    </Helmet>
  );
};

export default SEO;
